var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ig-iframe',{staticStyle:{"margin":"0px 18px"},attrs:{"src":_vm.src,"height":"120vh"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }